export const navbar = {
  Search: 'Suchen',
  SearchPlaceholder: 'Was möchtest du abspielen?',
  Home: 'Startseite',
  'Your Library': 'Deine Bibliothek',
  'Collapse your library': 'Bibliothek einklappen',
  'Expand your library': 'Bibliothek ausklappen',
  Language: 'Sprache',
  'Contact me': 'Kontaktiere mich',
  'Choose a language': 'Wähle eine Sprache',
};
